import { useCallback, useContext } from "react";
import { NavigatorContext } from "../../../context";

export const useBackIcon = ({ backLink }) => {
  const { navigateTo } = useContext(NavigatorContext);
  const navigateToBack = useCallback(
    () => navigateTo({ route: backLink }),
    [navigateTo, backLink]
  );
  return {
    navigateToBack,
  };
};
